import { render, staticRenderFns } from "./recycler.vue?vue&type=template&id=0080317d&scoped=true&"
import script from "./recycler.vue?vue&type=script&lang=js&"
export * from "./recycler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0080317d",
  null
  
)

export default component.exports